<template>
  <div id="unicom-notice-bar">
    <van-notice-bar
      color="#275BF5"
      background="#E8EdFD"
      :speed="30"
      :scrollable="scrollable"
      :text="textContent"
    >
      <template slot="left-icon">
        <img class="left-icon" src="/pub/pre/h5/icon/icon_horn_blue.png" />
      </template>
    </van-notice-bar>
  </div>
</template>

<script>
export default {
  name: 'UnicomNoticeBar',
  props: {
    text: {
      type: String,
      default: ''
    },
    pageType: {
      type: String,
      default: ''
    },
    scrollable: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      textContent: ''
    }
  },
  created () {
    if (this.pageType === 'adv_auth') {
      this.textContent = '已匹配放款机构，请确认资料。'
    } else if (this.pageType === 'borrow') {
      this.textContent = '恭喜您审核通过，尽快完成提现，避免额度失效。'
    } else if (this.pageType === 'borrow_result') {
      this.textContent = '本平台是正规的贷款服务平台，不会以任何名义向您收取费用，警惕各类电信网络诈骗，不随意透露身份证件、银行卡、短信验证码等个人信息。'
    } else if (this.pageType === 'repayment') {
      this.textContent = '为保障您的资金安全，请认准官方指定渠道还款。'
    } else if (this.pageType === 'auth_residentialAddress') {
      this.textContent = '该机构仅对限定浙江区域用户放款，请补充信息。'
    } else {
      this.textContent = this.text
    }
  },
  methods: {}
}
</script>

<style lang="less">
#unicom-notice-bar {
  height: .6rem;
  .van-notice-bar {
    height: 0.6rem;
    line-height: .6rem;
    text-align: center;
    padding: 0;
    border-radius: 1.6rem 0.4rem 0.4rem 1.6rem;
    font-size: .24rem;
  }
  .left-icon {
    width: 0.6rem;
    height: 0.6rem;
    margin-right: .1rem;
  }
}
</style>
